export const isIOSWebView = () => {
  const userAgent = window.navigator.userAgent.toLowerCase();
  const isIOS = /iphone|ipad|ipod/.test(userAgent);
  const isWebView = /(wkwebview|crios|fxios)/.test(userAgent) ||
                    // Common WebView indicators
                    (isIOS && !/(safari)/.test(userAgent));

  return isIOS && isWebView;
};

export function isElectronEnvironment() {
  // Check for typical Electron environment indicators
  const isElectron = (
    typeof window !== 'undefined' &&
    (
      //@ts-ignore
      window.process && window.process.type === 'renderer' ||
      typeof window.process?.versions?.electron !== 'undefined' ||
      typeof window.require === 'function' ||
      navigator.userAgent.toLowerCase().indexOf('electron/') > -1
    )
  );

  return isElectron;
}
